const HANDLE_CHANGE_INTELLIGENCE_DATE_CONTROLS = 'HANDLE_CHANGE_INTELLIGENCE_DATE_CONTROLS'

const responseChangeIntelligenceDateControls = data => {
  return {
    type: HANDLE_CHANGE_INTELLIGENCE_DATE_CONTROLS,
    data
  }
}

const openIntelligenceDateControls = () => {
  return (dispatch) => {
    dispatch(responseChangeIntelligenceDateControls(true))
  }
}

const closeIntelligenceDateControls = () => {
  return (dispatch) => {
    dispatch(responseChangeIntelligenceDateControls(false))
  }
}

export {
  HANDLE_CHANGE_INTELLIGENCE_DATE_CONTROLS,
  openIntelligenceDateControls,
  closeIntelligenceDateControls
}